import { Chip, styled } from '@mui/material';
import { AI_GRADIENT, AI_GRADIENT_ANIMATED } from '../../AIGradient.styles';

export const GradientBorderWrapper = styled('div')<{ $animated?: boolean }>(({ $animated }) => ({
  display: 'inline-flex',
  borderRadius: '16px',
  padding: '1.5px',
  background: AI_GRADIENT,
  ...($animated && {
    '@keyframes gradientSweep': {
      '0%': { backgroundPosition: '200% 50%' },
      '100%': { backgroundPosition: '0% 50%' },
    },
    backgroundSize: '200% 100%',
    animation: 'gradientSweep 1.5s linear infinite',
  }),
}));

const gradientLabelSx = {
  background: AI_GRADIENT,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 500,
};

export const StatusChip = styled(Chip)({
  backgroundColor: 'white',
  border: 'none',
  textTransform: 'none',
  '& .MuiChip-label': gradientLabelSx,
});

export const AnimatedStatusChip = styled(Chip)({
  backgroundColor: 'white',
  border: 'none',
  textTransform: 'none',
  '@keyframes gradientTextSweep': {
    '0%': { backgroundPosition: '200% 50%' },
    '100%': { backgroundPosition: '0% 50%' },
  },
  '& .MuiChip-label': {
    fontWeight: 500,
    background: AI_GRADIENT_ANIMATED,
    backgroundSize: '200% 100%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradientTextSweep 1.5s linear infinite',
  },
  '& .MuiChip-avatar': {
    width: '1rem',
    height: '1rem',
    marginLeft: '6px',
    backgroundColor: 'transparent',
  },
});

export const PlainStatusChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.common?.black,
  border: `1px solid ${theme.palette.common?.black}`,
  backgroundColor: 'transparent',
  textTransform: 'none',
}));
